import React, { useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Row,
} from "reactstrap"
import { Checkbox } from "antd"

const featuresList = [
  "Dashboard",
  "Library",
  "Calendar",
  "Statistics",
  "League Table",
]

const AddEditUserPlanModal = ({ isOpen, toggle, onSave, editingPlan }) => {
  const [formData, setFormData] = useState({
    planName: "",
    planPrice: "",
    features: [],
    duration: "",
  })

  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (editingPlan) {
      setFormData({
        planName: editingPlan.planName,
        planPrice: editingPlan.planPrice,
        features: editingPlan.features,
        duration: editingPlan?.duration,
      })
    } else {
      setFormData({
        planName: "",
        planPrice: "",
        features: [],
        duration: "",
      })
    }
  }, [editingPlan, isOpen])

  const validate = () => {
    let newErrors = {}
    if (!formData.planName) newErrors.planName = "Plan Name is required"
    if (!formData.planPrice) newErrors.planPrice = "Plan planPrice is required"
    if (isNaN(formData.planPrice)) newErrors.planPrice = "planPrice must be a number"
    if (formData.features.length === 0)
      newErrors.features = "Select at least one feature"

    if (!formData.duration) newErrors.endDate = "Duration is required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSave = () => {
    if (!validate()) return
    const newPlan = {
      planName: formData.planName,
      planPrice: parseFloat(formData.planPrice),
      features: formData.features,
      duration: formData?.duration,
    }
    onSave(newPlan, !!editingPlan , editingPlan?._id)
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        {editingPlan ? "Edit User Plan" : "Add New User Plan"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Plan Name</Label>
            <Input
              type="text"
              value={formData.planName}
              onChange={e => setFormData({ ...formData, planName: e.target.value })}
              invalid={!!errors.planName}
              placeholder="Enter Plan Name"
            />
            {errors.planName && <FormFeedback>{errors.planName}</FormFeedback>}
          </FormGroup>

          <Row>
            <FormGroup className="col-xl-8">
              <Label>Plan planPrice (£)</Label>
              <Input
                type="number"
                value={formData.planPrice}
                onChange={e =>
                  setFormData({ ...formData, planPrice: e.target.value })
                }
                invalid={!!errors.planPrice}
                placeholder="Enter planPrice in Pound"
              />
              {errors.planPrice && <FormFeedback>{errors.planPrice}</FormFeedback>}
            </FormGroup>
            <FormGroup className="col-xl-4">
              <Label>Plan Duration (in months)</Label>
              <Input
                type="number"
                value={formData.duration}
                onChange={e =>
                  setFormData({ ...formData, duration: e.target.value })
                }
                onKeyPress={e => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault() // block anything not 0–9
                  }
                }}
                invalid={!!errors.duration}
                placeholder="Enter Plan Duration"
              />
              {errors.duration && (
                <FormFeedback>{errors.duration}</FormFeedback>
              )}
            </FormGroup>
          </Row>

          {/* <Row>
            <FormGroup className="col-xl-6">
              <Label>Start Date</Label>
              <Input
                type="date"
                value={formData.startDate}
                onChange={e =>
                  setFormData({ ...formData, startDate: e.target.value })
                }
                invalid={!!errors.startDate}
              />
              {errors.startDate && (
                <FormFeedback>{errors.startDate}</FormFeedback>
              )}
            </FormGroup>

            <FormGroup className="col-xl-6">
              <Label>End Date</Label>
              <Input
                type="date"
                value={formData.endDate}
                onChange={e =>
                  setFormData({ ...formData, endDate: e.target.value })
                }
                invalid={!!errors.endDate}
              />
              {errors.endDate && <FormFeedback>{errors.endDate}</FormFeedback>}
            </FormGroup>
          </Row> */}

          <FormGroup>
            <Label>Features</Label>
            <div className="border rounded p-2">
              <Checkbox.Group
                options={featuresList}
                value={formData.features}
                onChange={checked =>
                  setFormData({ ...formData, features: checked })
                }
              />
            </div>
            {errors.features && (
              <div className="text-danger small mt-1">{errors.features}</div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSave}>
          {editingPlan ? "Update" : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddEditUserPlanModal
